import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import 'rxjs/Rx';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../../global';
import {Role} from './role.model';
import {
  RequestParameters
} from '../../shared/models/request-parameters/parameter.model';
import {forEach} from '@angular/router/src/utils/collection';

@Injectable()

export class RoleService {

  constructor(private http: HttpClient) {
  }

  getRoles (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/roles', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
      (error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          content: JSON.parse(error.error).message
        });
      }
    );

  }

  getRole(reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/role/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postRole (role: Role) {

    const body = this.normalizeRoleData(role);

    return this.http.post(GlobalVariable.BASE_API_URL + '/roles', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putRole (role: Role) {

    const body = this.normalizeRoleData(role);

    return this.http.put(GlobalVariable.BASE_API_URL + '/role/' + role.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteRole (role: Role) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/role/' + role.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  private normalizeRoleData(role: Role): Role {
    const body = Object.assign({}, role);
    delete body.reference;

    let permissions = [];
    if (body.permissions.length > 0) {
      permissions = body.permissions.map(
        (permission) => {
          return permission.reference;
        }
      );
    }
    body.permissions = permissions;

    return body;
  }

}



// WEBPACK FOOTER //
// ./src/app/parameters/roles/role.service.ts